import React from "react";
import { Link } from "wouter";

const CTASection = () => {
  console.log('CTASection is rendering');
  return (
    <section className="relative py-24 bg-cover bg-center bg-no-repeat" 
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        position: 'relative'
      }}>
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-blue-700/80"></div>
      <div className="container mx-auto px-4 relative z-10 text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-6 text-white">
          Ready to Fix Your Device?
        </h2>
        <p className="text-xl md:text-2xl mb-10 max-w-3xl mx-auto text-gray-100">
          Visit our store at Yorkgate Mall for professional repairs and fast service.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-6">
          <Link
            href="/booking"
            className="inline-block bg-white hover:bg-gray-100 text-primary text-lg font-semibold px-10 py-4 rounded-full transition-all transform hover:scale-105 shadow-xl hover:shadow-2xl"
          >
            Book a Repair
          </Link>
          <Link
            href="/contact"
            className="inline-block border-2 border-white text-white hover:bg-white/10 text-lg font-semibold px-10 py-4 rounded-full transition-all transform hover:scale-105"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
